import { Contact } from '~api/address_book';
import { ShippingMethod } from '~api/selfcare';
import { CustomerInfo } from '~api/som';
import { Addon, ShipmentData, ShipmentTemplate, Tag } from '~api/userprofile';

import { useForm, useFormContext } from 'react-hook-form';

// Has to be compatible with ShipmentUpsert since a lot of components are reused between the two pages.
export type TemplateUpsert = Omit<
  ShipmentData,
  'shipping_method' | 'address_from' | 'address_to' | 'address_return' | 'customer_info'
> & {
  id?: string;
  contact_from?: Contact;
  contact_to?: Contact;
  contact_return?: Contact;
  customer_info?: Omit<CustomerInfo, 'address'> & { contact?: Contact };
  shipping_method?: ShippingMethod;
  tags?: Tag[];
};

export type ShipmentTemplateDetails = Omit<
  ShipmentData,
  'shipping_method' | 'address_from' | 'address_to' | 'address_return' | 'customer_info' | 'addons'
> &
  Pick<ShipmentTemplate, 'id'> & {
    addons?: (Addon & { description?: string })[];
    contact_from?: Contact;
    contact_to?: Contact;
    contact_return?: Contact;
    customer_info?: Omit<CustomerInfo, 'address'> & { contact?: Contact };
    shipping_method?: ShippingMethod;
    tag_ids?: string[];
    tags?: Tag[];
  };

export const useTemplateForm = useForm<TemplateUpsert>;
export const useTemplateFormContext = useFormContext<TemplateUpsert>;
